import { Box, Slide } from '@mui/material';
import React from 'react';
import { TransitionStatus } from '../public/Dialog/generic/utilities';
import { useDialogContext } from './DialogPresenter/DialogContext';

interface IProps {
  appear?: boolean;
  mountOnEnter?: boolean;
  unmountOnExit?: boolean;

  pageNumber?: number;
  currentPage?: number;
  lastCurrentPage?: number;
  children: React.ReactNode;

  transitionStatus?: TransitionStatus;

  onEntered?: () => void;
  onExited?: () => void;
}

export const goingForward = (
  currentPage: number,
  previousPage: number
): boolean => {
  return currentPage > previousPage;
};

export const calculateDirection = (
  currentPage: number,
  previousPage: number,
  transitionStatus: TransitionStatus | undefined
): 'left' | 'right' => {
  if (transitionStatus === undefined) {
    return goingForward(currentPage, previousPage) ? 'right' : 'left';
  }
  if (goingForward(currentPage, previousPage)) {
    return transitionStatus === 'entering' ? 'left' : 'right';
  } else {
    return transitionStatus === 'entering' ? 'right' : 'left';
  }
};

export const CustomeSlide: React.FC<IProps> = props => {
  const { currentPage, previousPage, transitionStatus, onEntered, onExited } =
    useDialogContext();

  const effectiveCurrentPage =
    props.currentPage !== undefined ? props.currentPage : currentPage;
  const effectiveLastCurrentPage =
    props.lastCurrentPage !== undefined ? props.lastCurrentPage : previousPage;
  const effectiveTransitionStatus =
    props.transitionStatus !== undefined
      ? props.transitionStatus
      : transitionStatus;
  const effectiveOnEntered = props.onEntered ?? onEntered;
  const effectiveOnExited = props.onExited ?? onExited;

  return (
    <Slide
      appear={props.appear === undefined || props.appear === true}
      direction={
        calculateDirection(
          effectiveCurrentPage,
          effectiveLastCurrentPage,
          effectiveTransitionStatus
        ) as 'left' | 'right'
      }
      in={
        props.pageNumber === effectiveCurrentPage &&
        effectiveTransitionStatus !== 'exiting'
      }
      mountOnEnter={props.mountOnEnter === false ? false : true}
      unmountOnExit={props.unmountOnExit === false ? false : true}
      onEntered={effectiveOnEntered}
      onExited={effectiveOnExited}
    >
      <Box>{props.children}</Box>
    </Slide>
  );
};
